import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

const MenuItemCard = ({ item }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const IconComponent = item.icon;

  return (
    <div className="col-span-6 sm:col-span-3 lg:col-span-2">
      <div className="group bg-white border border-slate-200/60 rounded-xl p-6 hover:shadow-lg hover:shadow-slate-900/5 hover:border-slate-300/60 transition-all duration-200 ease-in-out hover:-translate-y-1 h-full flex flex-col">
        <div className="flex items-start space-x-4 flex-1">
          <div className="flex-shrink-0">
            <div className="w-12 h-12 bg-gradient-to-br from-blue-50 to-blue-100 rounded-lg flex items-center justify-center text-xl group-hover:from-blue-600 group-hover:to-blue-700 group-hover:text-white transition-all duration-200">
              <IconComponent className="w-6 h-6 text-blue-600 group-hover:text-white" />
            </div>
          </div>
          <div className="flex-1 min-w-0 flex flex-col h-full">
            <h3 className="text-lg font-semibold text-slate-900 mb-2 group-hover:text-blue-600 transition-colors duration-200">
              {t(item.titleKey)}
            </h3>
            <p className="text-sm text-slate-600 leading-relaxed mb-4 flex-1">
              {t(item.descriptionKey)}
            </p>
            <div className="mt-auto">
              <button
                onClick={() => {
                  navigate(item.route);
                }}
                type="button"
                className="inline-flex items-center justify-center px-4 py-2 text-sm font-medium text-blue-600 bg-blue-50 border border-blue-200/60 rounded-lg hover:bg-blue-600 hover:text-white hover:border-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-all duration-200"
              >
                {t("Get Started")}
                <svg 
                  className="ml-2 w-4 h-4 transition-transform duration-200 group-hover:translate-x-0.5" 
                  fill="none" 
                  stroke="currentColor" 
                  viewBox="0 0 24 24"
                >
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                </svg>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MenuItemCard;